<template>
    <div>
      <div>
        <a-button v-if="!isEdit" type="primary" @click="isEdit=true">编辑</a-button>
        <template v-else>
          <a-button type="primary" @click="add">添加</a-button>
        </template>
      </div>
      <div>
        <a-table
          ref="table"
          bordered
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="checkOnlyInputObj"
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record,index">
          <a-popconfirm  v-if="isEdit" title="确定删除吗?" @confirm="() =>handleDelete(index)">
            <a>删除</a>
          </a-popconfirm>
        </span>
          <span slot="dictItemList" slot-scope="text, record,index">
          {{getNameList(text)}}
        </span>
        </a-table>
        <template v-if="isEdit">
          <a-button type="primary" @click="cancel">取消</a-button>
          <a-button type="primary" style="margin-left: 10px" @click="save">保存</a-button>
        </template>
      </div>
      <a-modal
        title="选择表单题目"
        :width="600"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel">
        <a-spin :spinning="confirmLoading">
        <a-form-model layout="horizontal" :model="formModal" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
          <a-form-model-item
            prop="formId"
            label="表单">
            <a-select
              placeholder="请选择"
              v-model="formModal.formId"
              showSearch
              :filterOption="filterOption"
              @change="formIdChange"
            >
              <a-select-option :value="item.id" v-for="item in formModal.formList">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            prop="formItemId"
            label="表单题目">
            <a-select
              placeholder="请选择"
              v-model="formModal.formItemId"
              showSearch
              :filterOption="filterOption"
              @change="formItemIdChange"
            >
              <a-select-option :value="item.id" v-for="item in formModal.formItemList">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item
            prop="dictItemValues"
            label="字典值">
            <a-select
              placeholder="请选择"
              :filterOption="filterOption"
              showSearch
              @change="dictItemChange"
              mode="multiple"
              v-model="formModal.dictItemValues"
            >
              <a-select-option :value="item.value" v-for="item in formModal.dictItemList">{{item.text}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
        </a-spin>
      </a-modal>
    </div>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  export default {
    name: 'CheckOnlyInput',
    props:{
      checkOnlyInput:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        isEdit:false,
        checkOnlyInputObj:[],
        visible:false,
        confirmLoading:false,
        formModal:{
          formList:[],
          formItemList:[],
          dictItemList:[],
          formId:'',
          formItemId:'',
          dictItemValues:[],
        },
        rules:{
          formId:[baseRules.requiredChange],
          formItemId:[baseRules.requiredChange],
          dictItemValues:[baseRules.requiredChange],
        },
        columns: [

          {
            title: '表单',
            align: "center",
            width: 200,
            ellipsis: true, //表格省略
            dataIndex: 'formName',
          },
          {
            title: '题目',
            ellipsis: true, //表格省略
            align: "center",
            dataIndex: 'formItemName',
          },
          {
            title: '字典值',
            ellipsis: true, //表格省略
            align: "center",
            dataIndex: 'dictItemList',
            scopedSlots: {customRender: 'dictItemList'},
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 100
          }
        ]
      }
    },
    watch:{
      checkOnlyInput(){
        this.initData()
      }
    },
    mounted(){
      this.initData()
    },
    methods:{
      initData(){
        this.checkOnlyInputObj = this.checkOnlyInput?JSON.parse(this.checkOnlyInput):[]
      },
      add(){
        this.formModal={
          formList:[],
          formItemList:[],
          dictItemList:[],
          formId:'',
          formItemId:'',
          dictItemValues:[],
        }
        this.confirmLoading = true
        getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.formModal.formList=res.result
            this.visible = true
          }
        }).finally(()=>{
          this.confirmLoading = false
        })
      },
      formIdChange(){
        this.formModal.formItemId = null
        this.formModal.dictItemValues = []
        this.confirmLoading = true
        if(this.formModal.formId){
          getAction('/project/projectFormItem/listAll',{formId:this.formModal.formId,scale:'0',elementType:'check'}).then(res=>{
            if(res.success){
              this.formModal.formItemList = res.result
            }
          }).finally(()=>{
            this.confirmLoading = false
          })
        }else{
          this.formModal.formItemList = []
        }
      },
      formItemIdChange(){
        this.formModal.dictItemValues = []
        if(this.formModal.formItemId){
          this.formModal.formItemList.forEach(item=>{
            if(item.id===this.formModal.formItemId){
              this.formModal.dictItemList = item.element.dictItemList
            }
          })
        }else{
          this.formModal.dictItemList = []
        }
      },
      dictItemChange(){

      },
      cancel(){
        this.initData()
        this.visible = false
        this.isEdit = false
      },
      handleDelete(index){
        this.checkOnlyInputObj.splice(index,1)
      },
      save(){
        this.$emit('onsubmit',JSON.stringify(this.checkOnlyInputObj))
        this.cancel()
      },
      getNameList(dictItemList){
        if(!dictItemList && dictItemList.length>0){
          return ''
        }
        const arrays = []
        // const dictItemList = JSON.parse(dictItems)
        dictItemList.forEach(item=>{
          arrays.push(item.text)
        })
        return arrays.toString()
      },
      handleOk(){
        const data = {}
        // formModal:{
        //   formList:[],
        //     formItemList:[],
        //     dictItemList:[],
        //     formId:'',
        //     formItemId:'',
        //     dictItemValues:[],
        // },
        data.formId = this.formModal.formId
        this.formModal.formList.forEach(item=>{
          if(item.id===data.formId){
            data.formName = item.name
          }
        })
        data.formItemId = this.formModal.formItemId
        this.formModal.formItemList.forEach(item=>{
          if(item.id===data.formItemId){
            data.formItemName = item.name
          }
        })
        data.dictItemList = []
        this.formModal.dictItemValues.forEach(value=>{
          this.formModal.dictItemList.forEach(item=>{
            if(item.value===value){
              data.dictItemList.push({
                value : value,
                text: item.text
              })
            }
          })
        })
        this.checkOnlyInputObj.push(data)
        this.handleCancel()
      },
      handleCancel(){
        this.visible = false
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

    }
  }
</script>

<style scoped>

</style>